import React, { ReactNode } from 'react';
import { Modal, ModalHeader, Table} from 'reactstrap';
import '../Icono/cardIcon.css';
import { PersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface MiModalProps {
    isOpen: boolean;
    titulo: string;
    toggle: () => void;
    data: PersonaInvDTO;
    children?: ReactNode;
}

export const ModalX: React.FC<MiModalProps> = ({ isOpen, toggle, titulo, data, children }) =>{
    return (
        <Modal className='modal-lg' isOpen={isOpen} toggle={toggle}>
            <ModalHeader><strong>{titulo}</strong></ModalHeader>
            <div style={{padding:'20px'}} >
                {children}
            </div>
        </Modal>
    )

}